import React, { useEffect, useState } from "react";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
// @material-ui/icons
import DeleteForeverOutlinedIcon from "@material-ui/icons/DeleteForeverOutlined";
import CreateOutlinedIcon from "@material-ui/icons/CreateOutlined";
import VisibilityOutlinedIcon from "@material-ui/icons/VisibilityOutlined";
// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "components/CustomButtons/Button.js";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import CardHeader from "components/Card/CardHeader.js";
import ReactTable from "components/Tables/ReactTable.js";
import { cardTitle } from "assets/jss/material-dashboard-pro-react.js";
import TableHeader from "components/Tables/TableHeader";
import { useHistory } from "react-router-dom";
import AlertModal from "components/Alerts/AlertModal";
import PersonIcon from "@material-ui/icons/Person";
import useAxios from "axios/httpService";
import { NotificationManager } from "components/common/ReactNotifications";
import { apiErrorHandler } from "helpers/apiErrorHandler";
import Loading from "components/Loading/Loading";
import { GetAllCustomerAdminsUrl } from "axios/adminAPIsUrls";
import { DeleteCustomerAdminUrl } from "axios/adminAPIsUrls";
import CustomSwitchLabel from "components/Checkboxes/CustomSwitchLabel";

const styles = {
  cardIconTitle: {
    ...cardTitle,
    marginTop: "15px",
    marginBottom: "0px",
  },
  mtZero: {
    marginTop: "0px",
  },
  ptZero: {
    paddingTop: "0px !important",
  },
};

const useStyles = makeStyles(styles);

const CustomerAdmin = () => {
  const history = useHistory();

  const pageSize = 8;
  const [currentPage, setCurrentPage] = useState(1);
  const [customerAdminId, setCustomerAdminId] = useState("");
  const [alert, setAlert] = useState(false);
  const [data, setData] = useState([]);

  const token = localStorage.getItem("token");
  const [
    { data: dataCustomerAdmin, error, loading },
    ExecuteGetAllCustomerAdminsUrl,
  ] = useAxios(GetAllCustomerAdminsUrl(currentPage, pageSize, token), {
    manual: true,
  });

  const [{ loading: deleteLoading }, ExecuteDeleteCustomerAdminUrl] = useAxios(
    DeleteCustomerAdminUrl(customerAdminId, token),
    {
      manual: true,
    }
  );

  const deletePathwayhandler = async () => {
    try {
      const res = await ExecuteDeleteCustomerAdminUrl();
      setAlert(!alert);
      NotificationManager.success("Pathway Deleted", 5000);
      ExecuteGetAllCustomerAdminsUrl();
    } catch (exception) {
      console.log("Error in Deleting Pathway", exception);
      apiErrorHandler(exception, history);
    }
  };

  useEffect(() => {
    // ExecuteGetInquiryTypeDetails();
    ExecuteGetAllCustomerAdminsUrl(currentPage);
  }, [currentPage]);

  useEffect(() => {
    if (dataCustomerAdmin) {
      setData(
        dataCustomerAdmin.data.map((prop, key) => {
          return {
            id: prop.CustomerId,
            organizationName: prop.CustomerName,
            industryType: prop.Industry,
            website: prop.Website,
            active: (
              <CustomSwitchLabel checked={prop.IsActive} noMarginPadding />
            ),
            actions: (
              // we've added some custom button actions
              <div className="actions-center">
                <Button
                  action
                  tooltipText="View Profile"
                  justIcon
                  round
                  simple
                  size="sm"
                  color="primary"
                  onClick={() =>
                    history.push(
                      `${window.location.pathname}/view/${prop.CustomerId}`
                    )
                  }
                >
                  <VisibilityOutlinedIcon />
                </Button>

                <Button
                  action
                  tooltipText="Edit Profile"
                  justIcon
                  round
                  simple
                  size="sm"
                  color="primary"
                  onClick={() =>
                    history.push(
                      `${window.location.pathname}/edit/${prop.CustomerId}`
                    )
                  }
                >
                  <CreateOutlinedIcon />
                </Button>
                <Button
                  action
                  tooltipText="Delete Profile"
                  justIcon
                  round
                  simple
                  size="sm"
                  color="primary"
                  onClick={() => toggleDelete(prop.CustomerId)}
                >
                  <DeleteForeverOutlinedIcon />
                </Button>
                <Button
                  justIcon
                  round
                  simple
                  size="sm"
                  color="primary"
                  action
                  tooltipText="Customer Users"
                  onClick={() =>
                    history.push(
                      `${window.location.pathname}/customers-users/${prop.CustomerId}`
                    )
                  }
                >
                  <PersonIcon />
                </Button>
              </div>
            ),
          };
        })
      );
    }
  }, [dataCustomerAdmin]);

  const toggleDelete = (id) => {
    setCustomerAdminId(id);
    setAlert(!alert);
  };

  const classes = useStyles();

  const columns = [
    {
      Header: "Organization Name",
      accessor: "organizationName",
      alignment: "center",
    },
    {
      Header: "Industry Type",
      accessor: "industryType",
      alignment: "center",
    },
    {
      Header: "Website",
      accessor: "website",
      alignment: "center",
    },
    {
      Header: "Active",
      accessor: "active",
      alignment: "center",
    },

    {
      Header: (
        <div
          style={{
            textAlign: "center",
          }}
        >
          Actions
        </div>
      ),
      accessor: "actions",
      alignment: "center",
    },
  ];
  // ERROR HANDLING
  if (error) {
    apiErrorHandler(error, history);
  }

  if (loading) {
    return <Loading loading />;
  }
  if (deleteLoading) {
    return <Loading deleteLoading />;
  }

  return (
    <GridContainer className={classes.center}>
      <AlertModal
        alert={alert}
        setAlert={setAlert}
        onDelete={() => deletePathwayhandler()}
        onCancel={() => setAlert(!alert)}
      />
      <GridItem xs={12}>
        <Card>
          <CardHeader>
            <TableHeader
              title="Profiles"
              goBackRoute="/superAdmin/manage-customers-profile"
            />
          </CardHeader>
          <CardBody>
            <ReactTable
              columns={columns}
              data={data}
              loading={loading}
              currentPage={dataCustomerAdmin && dataCustomerAdmin.currentPage}
              defaultPageSize={dataCustomerAdmin && dataCustomerAdmin.pageSize}
              totalItems={dataCustomerAdmin && dataCustomerAdmin.totalItem}
              totalPages={dataCustomerAdmin && dataCustomerAdmin.totalPage}
              setCurrentPage={setCurrentPage}
            />
          </CardBody>
        </Card>
      </GridItem>
    </GridContainer>
  );
};

export default CustomerAdmin;
